/* ShivaRam · Astrología Védica y Lectura de la Mano · complementos (se carga después de astro.js).
   - Indicador de pasos y descarga «Descargar mi lectura en PDF» (generada en el dispositivo con shivaram-pdf.js).
   - Resultados en orden: resumen, interpretación, consejos, preguntas, pequeño paso y productos.
     Los consejos se eligen según los elementos realmente calculados (Luna, ascendente o Sol, dasha actual)
     o según las líneas que la persona ha identificado en su mano. Nada es aleatorio ni inventado.
   - Productos seleccionados (entre 3 y 5, solo disponibles y con precio) en el idioma de la página.
   - Búsqueda opcional de localidades de todo el mundo (OpenStreetMap, servicio Photon de Komoot):
     solo se envía el nombre escrito y solo cuando la persona pulsa el botón.
   Textos: astro-textos-extra.js (es, en, fr, de, pt). No guarda nada ni usa cookies. */
(function () {
  'use strict';
  var A = window.ShivaAstro;
  if (!A || !A.root) return;
  var root = A.root, el = A.el;
  var LANG = (root.getAttribute('data-lang') || 'es').slice(0, 2);
  var ROOT = root.getAttribute('data-root') || '/';
  var TX = window.ASTRO_TX || {};
  var PT = TX[LANG] || TX.es;
  if (!PT) return;
  var panels = {};
  [].forEach.call(root.querySelectorAll('[data-astro-panel]'), function (p) { panels[p.getAttribute('data-astro-panel')] = p; });
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (m, k) { return o[k] != null ? o[k] : m; }); }
  function txt(n) { return n ? String(n.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  var ICONO_PDF = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 3v12m0 0l-5-5m5 5l5-5M5 19h14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- productos seleccionados (sustituye a la versión de astro.js: 5 idiomas y entre 3 y 5 productos) ---------- */
  if (PT.F) Object.keys(PT.F).forEach(function (k) { if (A.FUENTES[k]) A.FUENTES[k].f = PT.F[k]; });
  var SORTS = ['best-selling', 'created-descending', 'price-ascending', 'title-ascending', 'manual'];
  var cache = {};
  function base() { return ROOT === '/' ? '' : ROOT.replace(/\/$/, ''); }
  function fetchFuente(key) {
    if (cache[key]) return Promise.resolve(cache[key]);
    var f = A.FUENTES[key]; if (!f) return Promise.resolve([]);
    var url = base() + f.u + (f.u.indexOf('?') > -1 ? '&' : '?') + 'section_id=astro-productos&sort_by=' + SORTS[Math.floor(Math.random() * SORTS.length)];
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var m = /<script[^>]*data-astro-productos[^>]*>([\s\S]*?)<\/script>/.exec(html);
      if (!m) return [];
      var data = JSON.parse(m[1]);
      if (f.u.indexOf('filter.') > -1 && !data.fa) return []; // filtro sin efecto: no mostrar productos sin relación
      var items = (data.items || []).filter(function (p) { return p.u && p.p; }).map(function (p) { p.k = key; return p; });
      cache[key] = items; return items;
    }).catch(function () { return []; });
  }
  A.productos = function (wrap, keys, objetivo) {
    objetivo = Math.max(3, Math.min(5, objetivo || 5));
    var reserva = ['velas', 'diarios', 'incienso'].filter(function (k) { return A.FUENTES[k] && keys.indexOf(k) < 0; }); // reserva sin filtros
    wrap.innerHTML = '';
    wrap.appendChild(el('h3', { class: 'astro__h3', text: PT.prodTit }));
    wrap.appendChild(el('p', { class: 'astro__lead', text: PT.prodLead }));
    var grid = el('div', { class: 'astro__grid', 'aria-busy': 'true' }, [el('p', { class: 'astro__loading', text: PT.buscando })]);
    wrap.appendChild(grid);
    Promise.all(keys.concat(reserva).map(fetchFuente)).then(function (todo) {
      var vistos = {}, elegidos = [], res = todo.slice(0, keys.length);
      for (var ronda = 0; ronda < 3 && elegidos.length < objetivo; ronda++) {
        if (ronda === 2) { if (elegidos.length >= 3) break; res = todo.slice(keys.length); } // reserva solo si faltan productos
        res.forEach(function (items) {
          if (elegidos.length >= objetivo || !items.length) return;
          var pool = A.shuffle(items).filter(function (p) { return !vistos[p.u]; });
          if (pool[0]) { vistos[pool[0].u] = 1; elegidos.push(pool[0]); }
        });
      }
      grid.innerHTML = ''; grid.removeAttribute('aria-busy');
      if (!elegidos.length) { grid.appendChild(el('p', { class: 'astro__note', text: PT.sinProd })); return; }
      elegidos.forEach(function (p) {
        var b0 = base(), href = b0 && p.u.indexOf(b0 + '/') !== 0 ? b0 + p.u : p.u; // la URL de Shopify ya puede llevar el idioma
        grid.appendChild(el('article', { class: 'astro__prod' }, [
          el('a', { class: 'astro__prod-img', href: href }, [el('img', { src: p.i, alt: p.a, loading: 'lazy', width: '480', height: '480' })]),
          el('div', { class: 'astro__prod-body' }, [
            el('h4', {}, [el('a', { href: href, text: p.t })]),
            el('p', { class: 'astro__price', text: (p.v ? PT.desde : '') + p.p }),
            el('p', { class: 'astro__stock', text: PT.disponible }),
            el('p', { class: 'astro__why', text: (A.FUENTES[p.k] || {}).f || '' }),
            el('a', { class: 'astro__btn astro__btn--small', href: href, text: PT.verProducto })
          ])
        ]));
      });
      wrap.appendChild(el('p', { class: 'astro__note', text: PT.avisoProd }));
    });
  };

  /* ---------- pasos y barra de descarga ---------- */
  function pasosEl(lista, actual) {
    var ol = el('ol', { class: 'astro__steps', 'aria-label': PT.pasos });
    lista.forEach(function (t, i) {
      var li = el('li', { class: 'astro__step' + (i + 1 < actual ? ' is-done' : i + 1 === actual ? ' is-current' : '') }, [el('span', { class: 'astro__step-n', text: String(i + 1) }), el('span', { class: 'astro__step-t', text: t })]);
      if (i + 1 === actual) li.setAttribute('aria-current', 'step');
      ol.appendChild(li);
    });
    return ol;
  }
  function decorarPanel(id) {
    var p = panels[id]; if (!p) return;
    var top = p.firstElementChild; if (!top || top.getAttribute('data-astro-dec')) return;
    var paso = 0;
    if (id === 'jyotish') paso = top.classList.contains('astro__report') ? 2 : top.classList.contains('astro__form') ? 1 : 0;
    else paso = top.classList.contains('astro__report') ? 3 : top.classList.contains('astro__obs') ? 2 : top.classList.contains('astro__mano') ? 1 : 0;
    if (!paso) return;
    top.setAttribute('data-astro-dec', '1');
    top.insertBefore(pasosEl(id === 'jyotish' ? PT.jy : PT.ma, paso), top.firstChild);
    if (id === 'jyotish' && paso === 1) buscadorMundial(top);
    if (top.classList.contains('astro__report')) {
      try { ordenarInforme(top, id); } catch (e) { /* si algo falla, el informe original sigue visible */ }
      barraPDF(top, id);
    }
  }
  function barraPDF(rep, id) {
    var estado = el('p', { class: 'astro__pdf-estado', role: 'status', 'aria-live': 'polite' });
    var chk = null, extra = [];
    if (id === 'mano' && rep.querySelector('.astro__foto-img img')) {
      chk = el('input', { type: 'checkbox', id: 'astro-pdf-foto' });
      extra.push(el('label', { class: 'astro__pdf-foto', for: 'astro-pdf-foto' }, [chk, el('span', { text: PT.foto })]));
      extra.push(el('p', { class: 'astro__pdf-hint', text: PT.fotoHint }));
    }
    function boton(cls) { return el('button', { type: 'button', class: 'astro__btn ' + cls, 'data-astro-pdf': '', html: ICONO_PDF + '<span>' + PT.pdfBtn + '</span>', onclick: function () { generarPDF(rep, id, chk && chk.checked, estado); } }); }
    var barra = el('div', { class: 'astro__pdfbar' }, [
      el('div', { class: 'astro__pdfbar-txt' }, [el('strong', { text: PT.barTit }), el('span', { text: id === 'jyotish' ? PT.barJy : PT.barMa })].concat(extra)),
      el('div', { class: 'astro__pdfbar-btns' }, [boton('astro__btn--gold')])
    ]);
    var ancla = rep.querySelector(':scope > .astro__lead') || rep.querySelector(':scope > .astro__sec--resumen') || rep.querySelector(':scope > h2');
    ancla.parentNode.insertBefore(estado, ancla.nextSibling);
    ancla.parentNode.insertBefore(barra, ancla.nextSibling);
    var fin = rep.querySelector('.astro__actions--end');
    if (fin) fin.insertBefore(boton(''), fin.firstChild);
  }
  Object.keys(panels).forEach(function (id) {
    if (!window.MutationObserver) return;
    new MutationObserver(function () { decorarPanel(id); }).observe(panels[id], { childList: true });
  });

  /* ---------- consejos personalizados ---------- */
  var ELEM = ['fuego', 'tierra', 'aire', 'agua']; // Aries fuego, Tauro tierra, Géminis aire, Cáncer agua…
  var respMano = {};
  if (panels.mano) panels.mano.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.classList || !f.classList.contains('astro__obs')) return;
    var r = {};
    [].forEach.call(f.querySelectorAll('input[type="radio"]:checked'), function (i) { r[i.name] = i.value; });
    respMano = r;
  }, true);

  function lista(items) {
    return el('ul', { class: 'astro__tips' }, items.map(function (x) { return el('li', {}, [el('strong', { text: x.b }), el('span', { text: ' ' + x.t })]); }));
  }
  function seccionTag(cls, tag, tit, hijos) {
    return el('section', { class: 'astro__sec ' + cls }, [el('h3', {}, [el('span', { class: 'astro__tag astro__tag--sug', text: tag }), tit])].concat(hijos));
  }
  function consejosJyotish() {
    var J = window.ShivaJyotish, e = J && J._estado && J._estado();
    if (!e || !e.r) return null;
    var r = e.r, S = J.SIGNOS, X = PT.JY, sig = function (lon) { return Math.floor(lon / 30); };
    var sL = sig(r.sid.luna), eL = ELEM[sL % 4];
    var tips = [{ b: fmt(PT.segLuna, { signo: S[sL].n }), t: X.m[eL] }];
    if (r.conHora) { var sA = sig(r.asc); tips.push({ b: fmt(PT.segAsc, { signo: S[sA].n }), t: X.a[ELEM[sA % 4]] }); }
    else { var sS = sig(r.sid.sol); tips.push({ b: fmt(PT.segSol, { signo: S[sS].n }), t: X.a[ELEM[sS % 4]] }); }
    var actual = null, ahora = Date.now();
    (e.dashas || []).forEach(function (d) { if (d.ini <= ahora && ahora < d.fin) actual = d; });
    if (actual && X.d[actual.lord]) tips.push({ b: fmt(PT.segDasha, { graha: PT.G[actual.lord] }), t: X.d[actual.lord] });
    tips.push({ b: PT.general, t: X.g });
    var paso = actual && X.pd[actual.lord] ? { t: X.pd[actual.lord], base: fmt(PT.segDasha, { graha: PT.G[actual.lord] }) } : { t: X.pe[eL], base: fmt(PT.segLuna, { signo: S[sL].n }) };
    return { tips: tips, paso: paso, intro: PT.introJy, nota: r.conHora ? '' : PT.sinHora };
  }
  function consejosMano() {
    var R = respMano, M = PT.MA;
    if (!R.palma || !R.dedos) return null;
    var elem = R.palma === 'cuadrada' ? (R.dedos === 'cortos' ? 'tierra' : 'aire') : (R.dedos === 'cortos' ? 'fuego' : 'agua');
    var tips = [], nd = [];
    ['corazon', 'cabeza', 'vida', 'destino', 'union'].forEach(function (id) {
      var v = R[id];
      if (v === 'nd') { nd.push(M.n[id]); return; }
      if (v && M.t[id] && M.t[id][v] && tips.length < 4) tips.push({ b: M.n[id], t: M.t[id][v] });
    });
    var etiqueta = fmt(PT.segMano, { elem: M.el[elem] });
    tips.push({ b: etiqueta, t: M.e[elem] });
    if (tips.length < 3) tips.push({ b: PT.general, t: M.g });
    return { tips: tips, paso: { t: M.pe[elem], base: etiqueta }, intro: PT.introMa, nota: nd.length ? fmt(PT.nd, { lineas: nd.join(', ') }) : '' };
  }
  // reordena el informe: resumen → interpretación → consejos → preguntas → pequeño paso → productos
  // avisos de fiabilidad de la hora: fechas anteriores a 1970, zona sustituida por un navegador antiguo, coordenadas
  function avisosHora(rep) {
    var J = window.ShivaJyotish, e = J && J._estado && J._estado(), C = window.ShivaCalc, calc = rep.querySelector('.astro__sec--calc');
    if (!e || !e.o || !calc) return;
    var o = e.o, sust = C && C.sustitutas && C.sustitutas[o.lugar.tz];
    if (o.lugar.manual) {
      // con coordenadas propias no mostramos la zona de una ciudad cercana: solo la diferencia indicada por la persona
      var dd = calc.querySelectorAll('.astro__datos dd'); if (dd[2]) dd[2].textContent = o.lugar.n;
      if (o.offManual !== null && dd[4]) { var t4 = dd[4].textContent; dd[4].textContent = t4.split(' · ')[0] + ' ' + ((t4.match(/\([^)]*\)\s*$/) || [''])[0]); }
    }
    if (o.offManual === null && sust) calc.appendChild(el('p', { class: 'astro__aviso', text: fmt(PT.tzAntiguo, { tz: o.lugar.tz, alt: sust }) }));
    if (o.offManual === null && o.y < 1970) calc.appendChild(el('p', { class: 'astro__aviso astro__aviso--suave', text: PT.pre1970 }));
  }
  function ordenarInforme(rep, id) {
    if (id === 'jyotish') { try { avisosHora(rep); } catch (err) { /* el informe sigue visible */ } }
    var c = id === 'jyotish' ? consejosJyotish() : consejosMano();
    var resumen = rep.querySelector(':scope > .astro__sec--resumen');
    var preguntas = rep.querySelector(':scope > .astro__sec--soft');
    var acciones = [].filter.call(rep.querySelectorAll(':scope > .astro__actions'), function (a) { return !a.classList.contains('astro__actions--end'); })[0];
    var h2 = rep.querySelector(':scope > h2');
    if (resumen) {
      var h = resumen.querySelector('h3'); if (h) h.textContent = PT.resumenTit;
      rep.insertBefore(resumen, h2 ? h2.nextSibling : rep.firstChild);
    }
    if (!acciones) return;
    if (c) {
      var hijos = [el('p', { class: 'astro__sec-intro', text: c.intro }), lista(c.tips)];
      if (c.nota) hijos.push(el('p', { class: 'astro__hint', text: c.nota }));
      rep.insertBefore(seccionTag('astro__sec--consejos', PT.tagSug, PT.consejosTit, hijos), acciones);
    }
    if (preguntas) {
      var hp = preguntas.querySelector('h3'); if (hp) hp.textContent = PT.preguntasTit;
      rep.insertBefore(preguntas, acciones);
    }
    if (c) {
      rep.insertBefore(el('section', { class: 'astro__sec astro__sec--paso' }, [el('h3', { text: PT.pasoTit }), el('p', { class: 'astro__paso', text: c.paso.t }), el('p', { class: 'astro__hint', text: fmt(PT.pasoNota, { base: c.paso.base }) })]), acciones);
      rep.insertBefore(el('p', { class: 'astro__aviso astro__aviso--suave', text: PT.aviso }), acciones);
    }
    // productos: se muestran directamente al final, sin pulsar ningún botón
    var b = acciones.querySelector('button');
    acciones.hidden = true;
    if (b) b.click();
  }

  /* ---------- búsqueda mundial de localidades (OpenStreetMap · Photon) ---------- */
  function nrm(s) { return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[’'`´]/g, '').replace(/\s+/g, ' ').trim(); }
  var TIPOS_OK = { city: 1, town: 1, village: 1, hamlet: 1, municipality: 1, suburb: 1, locality: 1, borough: 1, quarter: 1, neighbourhood: 1, isolated_dwelling: 1, island: 1, farm: 1 };
  var NOMBRES = null;
  function nombrePais(cc, def) { // nombre del país en el idioma de la página (no en el del servicio de búsqueda)
    try { NOMBRES = NOMBRES || new Intl.DisplayNames([LANG], { type: 'region' }); return NOMBRES.of(String(cc).toUpperCase()) || def || cc; } catch (e) { return def || cc; }
  }
  function buscadorMundial(form) {
    var J = window.ShivaJyotish, inCiudad = form.querySelector('#jy-ciudad'), campo = form.querySelector('.astro__field--city');
    if (!J || !inCiudad || !campo) return;
    var res = el('ul', { class: 'astro__mundo-lista', hidden: 'hidden' });
    var msg = el('p', { class: 'astro__hint astro__mundo-msg', 'aria-live': 'polite' });
    var nota = el('div', { class: 'astro__hint astro__mundo-tz', 'aria-live': 'polite' });
    var btn = el('button', { type: 'button', class: 'astro__btn astro__btn--ghost astro__btn--small astro__mundo-btn', text: PT.mundoBtn });
    var ocupado = false;
    form.setAttribute('data-tz-pendiente', '');
    btn.addEventListener('click', function () {
      if (ocupado) return;
      var q = inCiudad.value.split('·')[0].replace(/[()]/g, ' ').trim();
      res.hidden = true; res.innerHTML = ''; nota.innerHTML = ''; form.setAttribute('data-tz-pendiente', '');
      if (q.length < 2) { msg.textContent = PT.mundoCorto; inCiudad.focus(); return; }
      if (navigator.onLine === false) { msg.textContent = PT.errOffline; return; }
      ocupado = true; btn.disabled = true; msg.textContent = PT.buscandoMundo;
      var url = 'https://photon.komoot.io/api/?limit=12&q=' + encodeURIComponent(q) + (/^(en|de|fr)$/.test(LANG) ? '&lang=' + LANG : '');
      var ctl = window.AbortController ? new AbortController() : null, agotado = false;
      var reloj = setTimeout(function () { agotado = true; if (ctl) ctl.abort(); }, 12000);
      fetch(url, { credentials: 'omit', referrerPolicy: 'no-referrer', signal: ctl ? ctl.signal : undefined }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (data) {
        if (agotado) throw new Error('timeout');
        var vistos = {}, items = [];
        (data.features || []).forEach(function (f) {
          var p = f.properties || {}, g = f.geometry && f.geometry.coordinates;
          if (!g || !p.name || !p.countrycode) return;
          var ok = (p.osm_key === 'place' && TIPOS_OK[p.osm_value]) || (p.osm_key === 'boundary' && p.osm_value === 'administrative' && /^(city|locality|district)$/.test(p.type || ''));
          if (!ok) return;
          var reg = [p.county, p.state].filter(function (x, i, a) { return x && x !== p.name && a.indexOf(x) === i; }).join(' · ');
          var k = nrm(p.name + '|' + reg + '|' + p.countrycode);
          if (vistos[k]) return; vistos[k] = 1;
          items.push({ name: String(p.name).replace(/[,·()]/g, ' ').replace(/\s+/g, ' ').trim(), reg: reg.replace(/[,()]/g, ' ').replace(/\s+/g, ' ').trim(), st: p.state || '', pais: nombrePais(p.countrycode, p.country), cc: String(p.countrycode).toUpperCase(), lat: +g[1], lon: +g[0] });
        });
        items = items.slice(0, 8);
        if (!items.length) { msg.textContent = PT.sinRes; return; }
        msg.textContent = PT.elegir;
        items.forEach(function (it) {
          var b = el('button', { type: 'button', class: 'astro__mundo-op' }, [el('strong', { text: it.name }), el('span', { text: [it.reg, it.pais].filter(Boolean).join(' · ') + ' · ' + it.lat.toFixed(2) + ', ' + it.lon.toFixed(2) })]);
          b.addEventListener('click', function () { elegirMundial(it); });
          res.appendChild(el('li', {}, [b]));
        });
        res.hidden = false;
      }).catch(function () { msg.textContent = agotado ? PT.errTiempo : (navigator.onLine === false ? PT.errOffline : PT.errRed); }).then(function () { clearTimeout(reloj); ocupado = false; btn.disabled = false; });
    });
    // Zona horaria de una localidad de la búsqueda mundial. Solo se asigna automáticamente cuando se puede
    // confirmar: país con una única zona (zone.tab de la base tz/IANA) o región conocida (España, Portugal,
    // Büsingen). En los demás casos la persona elige la zona de una lista; nunca se usa «la ciudad más cercana».
    var REGIONES = {
      ES: [[/canari|canary|kanar/, 'Atlantic/Canary'], [/ceuta|melilla/, 'Africa/Ceuta'], [/./, 'Europe/Madrid']],
      PT: [[/madeira/, 'Atlantic/Madeira'], [/acores|azores|acores/, 'Atlantic/Azores'], [/./, 'Europe/Lisbon']],
      DE: [[/busingen/, 'Europe/Busingen'], [/./, 'Europe/Berlin']]
    };
    function zonaConfirmada(it) {
      var Z = (window.ASTRO_ZONAS || {})[it.cc];
      if (!Z || !Z.length) return { sin: true };
      if (Z.length === 1) return { tz: Z[0][0], unico: true };
      var R = REGIONES[it.cc];
      if (R) { var txtR = nrm(it.name + ' ' + it.reg); for (var i = 0; i < R.length; i++) if (R[i][0].test(txtR)) return { tz: R[i][1], region: it.st || it.reg || it.name }; }
      return { varias: Z };
    }
    function fijar(it, tz) {
      var todas = J.cargarCiudades(), n = it.name + (it.reg ? ' (' + it.reg + ')' : '');
      var nueva = { n: n, cc: it.cc, reg: '', lat: it.lat, lon: it.lon, tz: tz, k: nrm(n), osm: true };
      for (var i = todas.length - 1; i >= 0; i--) if (todas[i].osm && todas[i].k === nueva.k) todas.splice(i, 1);
      todas.push(nueva);
      // se elige a través del propio buscador del formulario, igual que si se hubiera escrito
      inCiudad.value = n;
      inCiudad.dispatchEvent(new Event('input', { bubbles: true }));
      var op = [].filter.call(form.querySelectorAll('#jy-lista li'), function (li) { return li.textContent.indexOf(n + ' · ') === 0; })[0];
      if (op) op.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
      form.removeAttribute('data-tz-pendiente');
    }
    function elegirMundial(it) {
      res.hidden = true; res.innerHTML = ''; msg.textContent = ''; nota.innerHTML = '';
      var z = zonaConfirmada(it);
      if (z.tz) {
        fijar(it, z.tz);
        nota.appendChild(el('p', { text: z.unico ? fmt(PT.tzUnico, { tz: z.tz, pais: it.pais }) : fmt(PT.tzRegion, { tz: z.tz, region: z.region, pais: it.pais }) }));
        return;
      }
      inCiudad.value = it.name + (it.reg ? ' (' + it.reg + ')' : '');
      if (z.sin) {
        // sin datos de zonas para ese país: coordenadas en los ajustes y diferencia horaria indicada por la persona
        var det = form.querySelector('.astro__details'), la = form.querySelector('#jy-lat'), lo = form.querySelector('#jy-lon');
        if (la && lo) { la.value = it.lat.toFixed(2); lo.value = it.lon.toFixed(2); }
        if (det) det.open = true;
        form.setAttribute('data-tz-pendiente', 'off');
        nota.appendChild(el('p', { text: fmt(PT.tzSinDatos, { pais: it.pais }) }));
        return;
      }
      form.setAttribute('data-tz-pendiente', 'zona');
      var cerca = function (o) { return Math.pow(o[1] - it.lat, 2) + Math.pow((o[2] - it.lon) * Math.cos(it.lat * Math.PI / 180), 2); };
      // primero las zonas principales («most areas» en la base tz), después el resto por distancia; la persona decide
      var ppal = function (o) { return /most|main/i.test(o[3] || '') ? 0 : 1; };
      var ops = z.varias.slice().sort(function (a, b) { return ppal(a) - ppal(b) || cerca(a) - cerca(b); });
      var sel = el('select', { id: 'jy-zona', class: 'astro__mundo-zona' }, [el('option', { value: '', text: PT.tzElige })].concat(ops.map(function (o) {
        return el('option', { value: o[0], text: o[0].split('/').pop().replace(/_/g, ' ') + (o[3] && LANG === 'en' ? ' — ' + o[3] : '') + ' (' + o[0] + ')' });
      })));
      sel.addEventListener('change', function () {
        if (!sel.value) { form.setAttribute('data-tz-pendiente', 'zona'); return; }
        fijar(it, sel.value);
        estadoZona.textContent = fmt(PT.tzElegida, { tz: sel.value });
      });
      var estadoZona = el('p', { 'aria-live': 'polite' });
      nota.appendChild(el('label', { for: 'jy-zona', text: fmt(PT.tzVarias, { pais: it.pais }) }));
      nota.appendChild(sel);
      nota.appendChild(estadoZona);
      sel.focus();
    }
    inCiudad.addEventListener('input', function (e) { if (e.isTrusted) { nota.innerHTML = ''; form.setAttribute('data-tz-pendiente', ''); } });
    campo.appendChild(el('div', { class: 'astro__mundo' }, [btn, el('p', { class: 'astro__hint', text: PT.mundoHint }), msg, res, nota, el('p', { class: 'astro__mundo-cred', text: PT.credito })]));
    // Antes de calcular: no se calcula con una zona horaria sin confirmar
    form.addEventListener('submit', function (e) {
      var err = form.querySelector('.astro__error'), pend = form.getAttribute('data-tz-pendiente');
      var la = form.querySelector('#jy-lat'), lo = form.querySelector('#jy-lon'), off = form.querySelector('#jy-off');
      var manual = la && lo && (la.value !== '' || lo.value !== ''), problema = '';
      if (pend === 'zona') problema = PT.tzFalta;
      else if ((manual || pend === 'off') && off && off.value === 'auto') problema = PT.coordOff;
      if (!problema) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (err) err.textContent = problema;
      var foco = pend === 'zona' ? form.querySelector('#jy-zona') : off;
      if (foco) { if (foco === off) { var det = form.querySelector('.astro__details'); if (det) det.open = true; } foco.focus(); }
    }, true);
  }

  /* ---------- PDF ---------- */
  var generando = false;
  function generarPDF(rep, id, conFoto, estado) {
    if (generando) return;
    var btns = [].slice.call(rep.querySelectorAll('[data-astro-pdf]'));
    function fin(msg, url) {
      generando = false;
      btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); });
      estado.innerHTML = ''; estado.appendChild(document.createTextNode(msg));
      if (url) { estado.appendChild(document.createTextNode(' ')); estado.appendChild(el('a', { href: url, target: '_blank', rel: 'noopener', text: PT.abrir })); }
    }
    if (!window.ShivaPDF) { fin(PT.error); return; }
    generando = true;
    btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    estado.textContent = PT.preparando;
    var img = conFoto ? rep.querySelector('.astro__foto-img img') : null;
    (img ? ShivaPDF.imagenAJpeg(img.src, 1400) : Promise.resolve(null)).then(function (foto) {
      var d = informeAPDF(rep, id, foto);
      fin(PT.listo, d.guardar(ShivaPDF.nombreArchivo(id === 'jyotish' ? PT.archJy : PT.archMa)));
    }).catch(function () { fin(PT.error); });
  }

  // carta del sur de la India dibujada en vectorial a partir de la carta que ve el visitante
  function cartaPDF(d, chart) {
    var C = ShivaPDF.C, S = 252, x0 = (ShivaPDF.PW - S) / 2, cs = S / 4;
    d.asegurar(S + 16);
    var y0 = d.y;
    d.rect(x0, y0, S, S, C.white, C.navy, 1.2);
    [].forEach.call(chart.querySelectorAll('.astro__cell'), function (cell) {
      var m = /grid-row:\s*(\d+).*grid-column:\s*(\d+)/.exec(cell.getAttribute('style') || '');
      if (!m) return;
      var cx = x0 + (+m[2] - 1) * cs, cy = y0 + (+m[1] - 1) * cs;
      if (cell.classList.contains('is-lagna')) { d.rect(cx, cy, cs, cs, [253, 244, 226]); d.rect(cx + 1.5, cy + 1.5, cs - 3, cs - 3, null, C.gold, 1.4); }
      d.rect(cx, cy, cs, cs, null, C.navy, 0.5);
      d.txt(txt(cell.querySelector('.astro__cell-sign')).toUpperCase(), cx + 5, cy + 11, 'H', 6, [120, 130, 148], 0.4);
      var pl = [].map.call(cell.querySelectorAll('.astro__cell-pl > *'), function (n) { return { t: txt(n), asc: n.tagName === 'B' }; });
      var yy = cy + 24;
      pl.forEach(function (p, i) {
        var col = i % 2, fila = Math.floor(i / 2);
        d.txt(p.t, cx + 6 + col * (cs / 2 - 2), yy + fila * 12, 'HB', 8.6, p.asc ? C.goldDark : C.navy);
      });
    });
    d.rect(x0 + cs, y0 + cs, cs * 2, cs * 2, C.navy);
    var c = chart.querySelector('.astro__chart-center');
    d.txt(txt(c && c.querySelector('strong')), ShivaPDF.PW / 2, y0 + S / 2 - 2, 'T', 15, C.gold, 0, 'center');
    d.txt(txt(c && c.querySelector('span')), ShivaPDF.PW / 2, y0 + S / 2 + 14, 'H', 7.5, [223, 228, 238], 0, 'center');
    d.y = y0 + S + 14;
  }

  // recorre el informe que ve el visitante y lo compone en el PDF (mismos datos, mismos textos, mismo orden)
  function informeAPDF(rep, id, foto) {
    var C = ShivaPDF.C;
    var tituloPag = txt(root.querySelector('.astro__title'));
    var d = ShivaPDF.doc({
      titulo: txt(rep.querySelector(':scope > h2')) || tituloPag,
      subtitulo: tituloPag,
      fecha: String(PT.fecha).replace('{fecha}', ShivaPDF.fechaHoy(LANG)),
      pie: 'ShivaRam · ' + location.hostname,
      pagina: PT.pagina
    });
    var SALTAR = ['astro__actions', 'astro__productos', 'astro__steps', 'astro__pdfbar', 'astro__pdf-estado'];
    function saltar(c) { return SALTAR.some(function (k) { return c.classList.contains(k); }); }
    function titulo(sec, op) {
      var h3 = sec.querySelector(':scope > h3'); if (!h3) return;
      var tag = h3.querySelector('.astro__tag'), resto = '';
      [].forEach.call(h3.childNodes, function (n) { if (n !== tag) resto += n.textContent; });
      d.seccion(resto.replace(/\s+/g, ' ').trim(), tag ? txt(tag) : null, { dorada: (tag && tag.classList.contains('astro__tag--gold')) || sec.classList.contains('astro__sec--consejos') || sec.classList.contains('astro__sec--paso') || sec.classList.contains('astro__sec--soft'), conSiguiente: (op && op.conSiguiente) || 110 });
    }
    function contenido(n) {
      [].forEach.call(n.children, function (c) {
        if (c.tagName === 'H3' || saltar(c)) return;
        if (c.classList.contains('astro__calc-grid')) {
          var dl = c.querySelector('dl.astro__datos'), pares = [];
          if (dl) [].forEach.call(dl.querySelectorAll('dt'), function (dt) { pares.push([txt(dt), txt(dt.nextElementSibling)]); });
          if (pares.length) d.datos(pares);
          var ch = c.querySelector('.astro__chart'); if (ch) cartaPDF(d, ch);
          return;
        }
        if (c.classList.contains('astro__tabla-wrap')) {
          var t = c.querySelector('table'); if (!t) return;
          var cab = [].map.call(t.querySelectorAll('thead th'), txt);
          var filas = [].map.call(t.querySelectorAll('tbody tr'), function (tr) { return { c: [].map.call(tr.children, txt), destacada: tr.classList.contains('is-lagna') }; });
          var pesos = cab.length === 5 ? [2.3, 2, 0.9, 1.7, 0.6] : null;
          d.tabla(cab, filas, { pesos: pesos });
          return;
        }
        if (c.classList.contains('astro__b')) { d.bloque(txt(c.querySelector('h4')), txt(c.querySelector('p')), { color: c.classList.contains('astro__b--nd') ? C.muted : null }); return; }
        if (c.classList.contains('astro__aviso')) { d.aviso(txt(c)); return; }
        if (c.classList.contains('astro__hint')) { d.nota(txt(c)); return; }
        if (c.classList.contains('astro__paso')) { d.p(txt(c), { f: 'TI', size: 13, color: C.navy, after: 4 }); return; }
        if (c.tagName === 'OL' && c.classList.contains('astro__dashas')) {
          var filasD = [];
          [].forEach.call(c.children, function (li) {
            var ahora = li.classList.contains('is-now');
            filasD.push({ c: [txt(li.querySelector('strong')) + (ahora ? '  (' + PT.actual + ')' : ''), txt(li.querySelector('span'))], destacada: ahora });
          });
          d.tabla(['Mahadasha', ''], filasD, { pesos: [1.4, 1] });
          return;
        }
        if (c.tagName === 'UL') {
          d.vinetas([].map.call(c.children, function (li) {
            var b = li.querySelector('strong');
            return b ? { b: txt(b) + (/[:：]$/.test(txt(b)) ? '' : ':'), t: txt(li).slice(txt(b).length).replace(/^[:\s]+/, '').trim() } : txt(li);
          }));
          return;
        }
        if (c.tagName === 'P') { d.p(txt(c), { lead: 15, after: 8 }); return; }
        if (c.tagName === 'DIV' && c.children.length) contenido(c);
      });
    }
    [].forEach.call(rep.children, function (c) {
      if (c.tagName === 'H2' || saltar(c) || c.classList.contains('astro__note')) return;
      if (c.classList.contains('astro__lead')) { d.p(txt(c), { color: C.muted, after: 8 }); return; }
      if (c.classList.contains('astro__mano-top')) {
        var sec = c.querySelector('section');
        titulo(sec, { conSiguiente: foto ? 300 : 110 });
        var cap = txt(c.querySelector('figcaption'));
        if (foto) {
          var y0, ancho = 170, alto = Math.min(250, ancho * foto.h / foto.w), anc2 = alto * foto.w / foto.h;
          d.asegurar(alto + 30); y0 = d.y;
          d.rrect(ShivaPDF.ML - 3, y0 - 3, anc2 + 6, alto + 6, 6, C.white, C.goldSoft, 0.8);
          d.imagen(foto, ShivaPDF.ML, y0, anc2, alto);
          d.txt(cap, ShivaPDF.ML + anc2 / 2, y0 + alto + 16, 'H', 8, C.muted, 0, 'center');
          var xr = ShivaPDF.ML + anc2 + 22, wr = ShivaPDF.PW - 54 - xr;
          var yAntes = d.y;
          var ul = sec.querySelector('ul');
          d.y = y0;
          var items = ul ? [].map.call(ul.children, function (li) { var b = li.querySelector('strong'); return b ? { b: txt(b), t: txt(li).slice(txt(b).length).trim() } : txt(li); }) : [];
          d.vinetas(items, { x: xr, w: wr });
          d.nota(txt(sec.querySelector('.astro__hint')), { x: xr, w: wr });
          d.y = Math.max(d.y, y0 + alto + 26, yAntes);
        } else {
          if (cap) d.datos([[PT.mano, cap]]);
          contenido(sec);
        }
        return;
      }
      if (c.tagName === 'SECTION') { titulo(c); contenido(c); return; }
      if (c.classList.contains('astro__aviso')) { d.aviso(txt(c)); return; }
      if (c.tagName === 'P') d.p(txt(c));
    });
    d.separador();
    var nota = rep.querySelector(':scope > .astro__note');
    if (nota) d.nota(txt(nota), { align: 'center' });
    var disc = root.querySelector('.astro__disclaimer');
    if (disc) d.nota(txt(disc), { align: 'center' });
    d.nota(PT.privacidad, { align: 'center' });
    return d;
  }

  A.pdf = function (id) { var p = panels[id], r = p && p.querySelector('.astro__report'); return r ? informeAPDF(r, id, null) : null; };
  Object.keys(panels).forEach(decorarPanel);
})();
